import { isEmpty } from 'lodash';
import { INTERFACE_BASE_ROUTE } from './route';
import { serializePageInputsToSearchParams } from './serializePageInputsToSearchParams';

export function getInterfacePageBuilderRoute({
  interfaceId,
  interfacePagePathOrSlug,
  pageInputs,
}: {
  interfaceId: string;
  interfacePagePathOrSlug?: string;
  pageInputs?: Record<string, unknown>;
}) {
  let route = interfacePagePathOrSlug
    ? `${INTERFACE_BASE_ROUTE}/${interfaceId}/builder/${interfacePagePathOrSlug}`
    : `${INTERFACE_BASE_ROUTE}/${interfaceId}/builder`;

  if (!isEmpty(pageInputs)) {
    const queryString = serializePageInputsToSearchParams(pageInputs).toString();
    if (queryString) {
      route = `${route}?${queryString}`;
    }
  }

  return route;
}

export function getInterfacePreviewRoute({
  interfaceId,
  interfacePagePathOrSlug,
  pageInputs,
}: {
  interfaceId: string;
  interfacePagePathOrSlug: string;
  pageInputs?: Record<string, unknown>;
}) {
  let route = `${INTERFACE_BASE_ROUTE}/${interfaceId}/preview/${interfacePagePathOrSlug}`;

  if (!isEmpty(pageInputs)) {
    const queryString = serializePageInputsToSearchParams(pageInputs).toString();
    if (queryString) {
      route = `${route}?${queryString}`;
    }
  }

  return route;
}

export function getTemplateComponentPreviewRoute(interfaceId: string) {
  return `${INTERFACE_BASE_ROUTE}/template-components/${interfaceId}/preview`;
}

export function getInterfacePageNavigationBuilderURL(interfaceId: string, interfacePageId: string) {
  return `${INTERFACE_BASE_ROUTE}/${interfaceId}/builder/page/${interfacePageId}`;
}

export function getInterfacePageNavigationPreviewURL(interfaceId: string, interfacePageId: string) {
  return `${INTERFACE_BASE_ROUTE}/${interfaceId}/preview/page/${interfacePageId}`;
}

export function getModulePageNavigationBuilderURL(interfaceId: string, moduleId: string) {
  return `${INTERFACE_BASE_ROUTE}/${interfaceId}/builder/module/${moduleId}`;
}

export function getModulePageNavigationPreviewURL(interfaceId: string, moduleId: string) {
  return `${INTERFACE_BASE_ROUTE}/${interfaceId}/preview/module/${moduleId}`;
}

export function getTemplateComponentBuilderURL(interfaceId: string, templateComponentId: string) {
  return `${INTERFACE_BASE_ROUTE}/template-components/${interfaceId}/builder/${templateComponentId}`;
}
